import React from 'react';
import "./css/Card.css";
import iosIcon from "./resources/ios.png";
import fullStar from "./resources/star.svg";
import halfStar from "./resources/star-half.svg";
import androidIcon from "./resources/android.png";
import websiteIcon from "./resources/website.svg";

function WhyCard({logo,title,appStore,playStore,website}) {
    return (
        <div className="card">
            <div className="card__image">
                <img src={logo} alt="Flight Logo" className="projectlogo" />
            </div>

            <div className="card__title">
                <h2>{title}</h2>
                <div className="card__title__rating">
                    <img src={fullStar} alt="fullStar" className="star" />
                    <img src={fullStar} alt="fullStar" className="star" />
                    <img src={fullStar} alt="fullStar" className="star" />
                    <img src={fullStar} alt="fullStar" className="star" />
                    <img src={halfStar} alt="fullStar" className="star" />
                </div>
            </div>

            <div className="card__availability" >
                <div className="card__availability__content" style={{display : appStore ? "flex" : "none"}}>
                    <img src={iosIcon} alt="App Store" className="appStore" />
                    <p>iOS</p>
                </div>
                <div className="card__availability__content" style={{display : playStore ? "flex" : "none"}}>
                    <img src={androidIcon} alt="App Store" className="playStore" />
                    <p>Android</p>
                </div>
                <div className="card__availability__content" style={{display : website ? "flex" : "none"}}>
                    <img src={websiteIcon} alt="App Store" className="appStore" />
                    <p>Website</p>
                </div>
            </div>
        </div>
    )
}

export default WhyCard
